import React from 'react';

import { ProjectBlockProps } from '../../_blocks/ProjectBlockGraphQL/types';
import classes from './ProjectBlock.module.scss';
import { DebugJsonBlock } from '../DebugJsonBlock';
import ResimdoIcon from '../ResimdoIcon';
import { Gutter } from '../Gutter';
import { useLocale, useTranslations } from 'next-intl';

export const ProjectBlock: React.FC<{
  className?: string;
  projectBlock: ProjectBlockProps;
}> = ({ className, projectBlock }) => {
  const locale = useLocale();
  const t = useTranslations();
  const { cost, time, additionalInfo, additionalTimeInfo, icons } = projectBlock;
  const hours = Math.floor(time / 60);
  const minutes = time % 60;
  return (
    <Gutter className={[className, classes.wrapper].filter(Boolean).join(' ')}>
      <div className={classes.projectBox}>
        <div className={classes.statsWrapper}>
          <div className={classes.cost}>
            <ResimdoIcon icon="sparschwein" mobileSize="SM" />
            <div className={classes.costText}>
              {cost
                .toLocaleString(locale.replace('_', '-'), {
                  style: 'currency',
                  currency: t('currency.code'),
                })
                .replace('.00', ',-')
                .replace(',00', ',-')}
              <div className={classes.smallText}>{t('projects.cost')}</div>
              {additionalInfo && <div className={classes.additionalText}>{additionalInfo}</div>}
            </div>
          </div>
          <div className={classes.separator}>{` `}</div>
          <div className={classes.time}>
            <ResimdoIcon icon="zeitersparnis" mobileSize="SM" />
            <div className={classes.timeText}>
              {`${hours}:${minutes.toString().padStart(2, '0')} ${t('time.hours.short')}`}
              <div className={classes.smallText}>{t('projects.time')}</div>
              {additionalTimeInfo && (
                <div className={classes.additionalText}>{additionalTimeInfo}</div>
              )}
            </div>
          </div>
          <div className={[classes.separator, classes.mobileHidden].filter(Boolean).join(' ')}>
            {` `}
          </div>
        </div>
        <div className={classes.mobileSpacer} />
        <div className={classes.icons}>
          {icons.map(({ id, icon }, index) => {
            return <ResimdoIcon key={`${id}-${index}`} icon={icon} size="MD" mobileSize="MD" />;
          })}
        </div>
      </div>
      <DebugJsonBlock block={{ ...projectBlock }} />
    </Gutter>
  );
};

export default ProjectBlock;
